// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"285":"app-messages-fr_CA","3546":"app-messages-en_CA","5496":"app-messages-any_Ext","6586":"product-metadata","7294":"app-messages-en_US"}[chunkId] + "." + {"285":"23fe820c","3546":"a664d0d7","5496":"99ae887a","6586":"4ee8d3de","7294":"74d34e93"}[chunkId] + ".chunk.js";
};